const SOURCES = [
  { id: "internal", en: "Internal", gr: "Εσωτερικό" },
  { id: "softone", en: "SoftOne", gr: "SoftOne" },
  { id: "ergani", en: "Ergani", gr: "Εργάνη" },
];

export function ScheduleSourceBar({ lang, value, onChange, pending, error }) {
  const gr = lang === "gr";
  return (
    <div
      style={{
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        gap: 10,
        flexWrap: "wrap",
        marginBottom: 10,
      }}
    >
      <div
        role="tablist"
        aria-label={gr ? "Προβολή προγράμματος" : "Schedule source"}
        style={{ display: "flex", background: "var(--surface2)", borderRadius: 10, padding: 3, gap: 3, flexShrink: 0 }}
      >
        {SOURCES.map((opt) => {
          const selected = value === opt.id;
          return (
            <button
              key={opt.id}
              type="button"
              role="tab"
              aria-selected={selected}
              onClick={() => onChange(opt.id)}
              style={{
                background: selected ? "var(--green)" : "transparent",
                color: selected ? "#fff" : "var(--text-secondary)",
                borderRadius: 8,
                padding: "5px 14px",
                fontSize: 12,
                fontWeight: 700,
                border: "none",
                cursor: "pointer",
              }}
            >
              {gr ? opt.gr : opt.en}
            </button>
          );
        })}
      </div>
      {value !== "internal" ? (
        <span style={{ fontSize: 12, color: error ? "#991B1B" : "var(--text-muted)", fontWeight: 600 }}>
          {error
            ? error
            : pending
              ? (gr ? "Φόρτωση…" : "Loading…")
              : (gr ? "Μόνο προβολή" : "Read only")}
        </span>
      ) : null}
    </div>
  );
}
